/**
 * Factory default layout for Activities table. Used for reset and as fallback when merging stored layout.
 */

import { ACTIVITY_COLUMNS } from '@/types';
import type { LayoutState } from './types';

const filteredColumns = ACTIVITY_COLUMNS.filter((col) => col.key !== 'percent_complete_type');

export const DEFAULT_LAYOUT: LayoutState = {
  columnState: filteredColumns.map((col, index) => ({
    key: String(col.key),
    visible: col.defaultVisible,
    order: index,
    decimalsEnabled: false,
    decimalPlaces: 2,
  })),
  columnSizing: {},
  groupBy: 'none',
  tableSettings: { highlightCritical: false, showTime: false },
  floatDisplayUnit: 'hours',
};
